import { useEffect, useRef, useTransition } from 'react';

import { loadSettings, updateSettingsAll } from '~modules/settings/api';
import { settingsStore } from '~pages/cabinet/admin/settings/settings.store.ts';
import { toastError, toastSuccess } from '~shared/ui';

export function useSettings() {
	const { settings, setSettings, changeValue } = settingsStore();
	const [pending, startLoading] = useTransition();
	const [saving, startSaveing] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startLoading(async () => {
				setSettings({});
				try {
					setSettings(await loadSettings());
				} catch (err) {
					console.error(err);
					toastError('Ошибка загрузки данных');
				}
			});
		}
	}, [setSettings]);

	function save() {
		startSaveing(async () => {
			try {
				await updateSettingsAll({ settings: Object.values(settings) });
				toastSuccess('Данные успешно сохранены');
			} catch (err) {
				console.error(err);
				toastError('Ошибка сохранения данных');
			}
		});
	}

	return { pending, settings, changeValue, save, saving };
}
